// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"pen\" on-select=\"parent.updatePenColor(color)\"> </toolbar-color-menu> ";
// Exports
module.exports = code;